module.exports = __webpack_public_path__ + "static/media/Skateboarder.e8b52884.jpg";